import { useEffect } from 'react';

interface PageMetadata {
    title: string;
    description?: string;
    image?: string;
    enabled?: boolean;
    type?: 'website' | 'article';
}

export const usePageMetadata = ({ title, description = '', image, enabled = true, type = 'website' }: PageMetadata) => {
    const url = window.location.href;
    useEffect(() => {
        if (!enabled) return;
        // Update title
        document.title = title;

        // Update meta description
        {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.setAttribute('name', 'description');
                document.head.appendChild(metaDescription);
            }
            metaDescription.setAttribute('content', description);
        }
        let imageUrl = new URL('/assets/landing/logo512.png', window.location.origin).href;
        try {
            const candidate = new URL(image || imageUrl, window.location.origin);
            if (candidate.protocol === 'http:' || candidate.protocol === 'https:') imageUrl = candidate.href;
        } catch {}
        const values = { 'og:title': title, 'og:description': description, 'og:image': imageUrl,
            'og:url': url, 'og:type': type, 'twitter:card': 'summary_large_image' };
        Object.entries(values).forEach(([property, value]) => {
            const attribute = property.startsWith('twitter:') ? 'name' : 'property';
            let meta = document.querySelector(`meta[${attribute}="${property}"]`);
            if (!meta) { meta = document.createElement('meta'); meta.setAttribute(attribute, property); document.head.appendChild(meta); }
            meta.setAttribute('content', value);
        });
    }, [title, description, image, enabled, type, url]);
};
